<template>
  <div class="reserv-cont" v-if="showLayout">
    <div class="no-reserv" v-if="reservations.length === 0">
      <h2>You have no upcoming reservations</h2>
      <div class="claim-button" @click="redirectHome">Browse Restaurants</div>
    </div>
    <div v-else>
      <reservation-item v-for="reservation in reservations" :reservation="reservation" :key="reservation._id" />
    </div>
  </div>
</template>

<script>
import axios from '../../../axios'
import ReservationItem from './ReservationItem'
export default {
  name: 'Reservations',
  components: {
    ReservationItem
  },
  data () {
    return {
      showLayout: false,
      reservations: []
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.api.currentUser
    }
  },
  mounted () {
    this.getReservations()
  },
  methods: {
    getReservations () {
      axios
        .get(`https://reservations.authorizelocal.com/api/book/list/email?email=${this.currentUser.email}`, {
          headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.accessToken}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.reservations = response.data.data
          }
          this.showLayout = true
        }).catch(() => {
          this.$vs.notify({
            title: 'Could not login to reservations',
            text: 'Login error',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.showLayout = true
        })
    },
    redirectHome () {
      this.$vs.loading()
      this.$router.push({
        name: 'dashboard'
      })
    }
  }
}
</script>

<style lang="scss">
.no-reserv {
  text-align: center;
  font-weight: 900;
  border:1px solid #ccc;
  border-radius: 7px;
  padding:20px;
  .claim-button{
    margin:15px auto 0 auto;
  }
}
.reserv-box {
  border-radius: 7px;
  border:1px solid #ccc;
  padding:20px;
  width:100%;
  margin:15px 0px;
}
.reserv-top{
  display:flex;
  gap:15px;
}
  .reserv-info{
  display:flex;
  flex-direction: column;
  gap:10px;
}
  .reserv-img {
    width:150px;
    height: 150px;
    border-radius: 7px;
    border:1px solid #ccc;
    background-image: url('../../../../public/image/about-us-background.webp');
    background-size: cover;
    background-position: center;
  }
  .reserv-rest-name {
    font-size:22px;
    font-weight: 900;
  }
  .reserv-status{
    font-weight: 700;
      i {
        font-size:16px;
      }
      .confirmed{
        color:#13aa37;
      }
      .cancelled{
        color:#ff2407;
      }
  }
  .reserv-time{
    display:flex;
    justify-content: space-between;
    align-items:center;
    gap:15px;
    .res-det {
      font-weight: 700;
      i{
        margin-right:5px;
        font-size:16px;
      }
    }
  }
  .reserv-options{
    display:flex;
    justify-content: space-between;
    align-items:center;
    gap:15px;
    font-weight: 700;
    color:#ff6b1e;
    cursor:pointer;
    div{
    &:hover{
      text-decoration: underline;
    }
    &.view-details{
      color:#0070eb
    }
  }
  }
  .reserv-details {
    width:100%;
  }
  .reserv-easy-nav{
    display:flex;
    justify-content: flex-start;
    gap:20px;
    margin:20px 0px;
    .reserv-button{
      color:#fff;
      font-weight: 700;
      border-radius: 7px;
      background-color:#0070eb;
      padding:5px 10px;
      font-size:22px;
      cursor:pointer;
    }
  }
  .reserv-notes{
    h2 {
      margin-bottom:15px;
      font-size:20px;
      font-weight: 900;
    }
    .dining-info{
      margin-bottom:20px;
      h2{
        font-size:18px;
        margin-bottom:5px;
        font-weight: 500;
      }
      i{
        font-size:21px;
        line-height: 18px;
        margin-right:5px;
        &.fa-info-circle{
          color:#0070eb;
        }
        &.fa-exclamation-triangle{
          color:orange;
        }
        &.fa-parking{
          color:#13aa37
        }
      }
    }
  }
  .reserv-footer{
    h2 {
      margin-bottom:15px;
      font-size:20px;
      font-weight: 900;
    }
  }
  .reserv-contact-info{
    display:flex;
    align-items: center;
    gap:20px;
  }
  .reserv-map {
    width:300px;
    height: 150px;
  }
  .reserv-footer-info{
    .contact-info{
      margin-bottom:15px;
      &:first-child{
        font-size:18px;
        font-weight: 600;
      }
      &:last-child{
        margin-bottom:0px;
      }
    }
  }
  @media (max-width:768px){
    .reserv-img{
      display:none;
    }
    .reserv-box{
      padding:10px;
    }
    .reserv-time{
      gap:5px;
    }
    .reserv-easy-nav{
      justify-content: center;
      flex-wrap: wrap;
      gap:5px;
    .reserv-button{
      font-size:17px;
      flex-basis:48%;
      width:100%;
    }
  }
  .reserv-options{
    flex-wrap: wrap;
    gap:5px;
    div{
      flex-basis:48%;
      flex-grow: 1;
      border:1px solid #ccc;
      border-radius: 7px;
      padding:5px 2px;
      text-align: center;
    }
  }
  .reserv-notes{
    .dining-info{
      i {
        font-size:16px;
      }
      h2{
        font-size:16px;
      }
    }
  }
  .reserv-contact-info{
    flex-direction: column;
    .reserv-map {
      width:100%;
    }
    .reserv-footer-info{
      width:100%;
    }
    .res-call-button{
      margin:0;
    }
  }
  }
</style>
